import React, { useState, useRef, useEffect } from "react";
import "./modal.scss";
import axios from "axios";
import Cookies from "js-cookie";
import "react-multi-date-picker/styles/layouts/prime.css";
import { connection } from "utils/apiConnection.ts";
import Select, { StylesConfig } from "react-select";
import useInput from "hooks/use-input";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import { isString } from "lodash";
import ReactTooltip from "react-tooltip";
import { RiDeleteBin5Line } from "react-icons/ri";
function Modal({
  setUpdater,
  setIsLoading,
  updater,
  otherInfo,
  setOtherInfo,
  allLeader,
  allProductTags,
  editModalData,
  customers
}) {
  useEffect(() => {
    setOtherInfo({
      ...otherInfo,
      fullname: "",
      user_mobile: ""
    });
  }, []);
  const [listInfoBank, setListInfoBank] = useState([
    // {
    //   numberCart: "1234567890123456",
    //   nameBank: "قرض الحسنه مهرایران",
    //   cartType: "نقدی",
    //   Shebanumber: "12300007123000989001",
    //   accountNumber: "12309856563439954",
    //   //status: "فعال ",
    // },
  ]);
  const [campian, setCampain] = useState([]);
  const pattern = /^09\d{9}$/;
  const tellPattern = /^0\d{10}$/;
  const patternNumbercart = /^\d{16}$/;
  const patternNumberAcount = /^\d{13}$/;
  const patternSheba = /^\d{24}$/;
  //اطلاعت بانکی
  const [cartType, setCartType] = useState([
    { value: " 0", label: "نقدی" },
    { value: "1", label: "اعتباری" }
  ]);

  const [infoBank, setInfoBank] = useState({
    numberCart: "",
    nameBank: "",
    cartType: "",
    Shebanumber: "",
    accountNumber: ""
  });
  // const bankJSON = JSON.stringify(infoBank);
  const [infoBankValid, setInfoBankValid] = useState({
    numberCart: true,
    nameBank: true,
    cartType: true,
    Shebanumber: true,
    accountNumber: true
  });
  const InfoBankValidation = () => {
    let temp = true;
    // if (infoBank.Shebanumber) {
    //   setInfoBankValid((prev) => {
    //     return { ...prev, Shebanumber: true };
    //   });
    // } else {
    //   temp = false;
    //   setInfoBankValid((prev) => {
    //     return { ...prev, Shebanumber: false };
    //   });
    // }
    // if (infoBank.accountNumber) {
    //   setInfoBankValid((prev) => {
    //     return { ...prev, accountNumber: true };
    //   });
    // } else {
    //   temp = false;
    //   setInfoBankValid((prev) => {
    //     return { ...prev, accountNumber: false };
    //   });
    // }
    if (infoBank.cartType) {
      setInfoBankValid(prev => {
        return { ...prev, cartType: true };
      });
    } else {
      temp = false;
      setInfoBankValid(prev => {
        return { ...prev, cartType: false };
      });
    }
    if (infoBank.nameBank) {
      setInfoBankValid(prev => {
        return { ...prev, nameBank: true };
      });
    } else {
      temp = false;
      setInfoBankValid(prev => {
        return { ...prev, nameBank: false };
      });
    }
    if (patternNumbercart.test(infoBank.numberCart)) {
      setInfoBankValid(prev => {
        return { ...prev, numberCart: true };
      });
    } else {
      temp = false;

      setInfoBankValid(prev => {
        return { ...prev, numberCart: false };
      });
    }
    if (patternNumberAcount.test(infoBank.accountNumber)) {
      setInfoBankValid(prev => {
        return { ...prev, accountNumber: true };
      });
    } else {
      temp = false;

      setInfoBankValid(prev => {
        return { ...prev, accountNumber: false };
      });
    }
    if (patternSheba.test(infoBank.Shebanumber)) {
      setInfoBankValid(prev => {
        return { ...prev, Shebanumber: true };
      });
    } else {
      temp = false;

      setInfoBankValid(prev => {
        return { ...prev, Shebanumber: false };
      });
    }

    return temp;
  };

  const RemoveInfoBank = index => {
    let newArray = listInfoBank.filter((value, index2, array) => {
      if (index == index2) {
        return false;
      } else {
        return true;
      }
    });
    setListInfoBank(newArray);
  };
  const title = useInput(value => value.trim() !== "");
  const [filterCat, setFilterCat] = useState();
  const [update, setUpdate] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const inputElement = useRef();

  function postHandler(otherInfo) {
    setIsLoading(true);
    let myFormData = new FormData();
    let usertoken = Cookies.get("token");
    let line_idsj = otherInfo.line_ids.map(value => value.value).join(",");
    let xd = otherInfo.main_admin_uid;
    if (xd == "-1") {
      myFormData.append("fullname", otherInfo.fullname);
      myFormData.append("mobile_admin", otherInfo.user_mobile);
    } else {
      myFormData.append("main_admin_uid", otherInfo.main_admin_uid);
    }

    if (otherInfo.title.trim() === "") {
      toast.error("نام    را وارد نمایید");
      return null;
    }
    if (otherInfo.main_cat === "-1") {
      toast.error("دسته بندی    را وارد نمایید");
      return null;
    }
    if (otherInfo.main_admin_uid.length == 0) {
      toast.error("کاربر را وارد نمایید");
      return null;
    }
    if (otherInfo.main_admin_uid.value == "-1" && otherInfo.user_mobile == "") {
      toast.error("موبایل کاربر را وارد کنید");
      return null;
    }
    setDisabledBtn(true);
    if (otherInfo.logo_file_id === undefined) otherInfo.logo_file_id = "";
    myFormData.append("supplier_id", otherInfo.suppliers__id);
    !isString(otherInfo.logo_file_id) &&
      myFormData.append("logo_file_id", otherInfo.logo_file_id);
    !isString(otherInfo.cover_file_id) &&
      myFormData.append("cover_file_id", otherInfo.cover_file_id);

    myFormData.append("usertoken", usertoken ? usertoken : "-1");
    myFormData.append("description", otherInfo.description);
    myFormData.append("main_cat", otherInfo.main_cat);
    myFormData.append("tell1", otherInfo.tell1);
    myFormData.append("tell2", otherInfo.tell2);
    myFormData.append("email", otherInfo.email);
    myFormData.append("mobile", otherInfo.mobile);
    myFormData.append("start_hour", otherInfo.start_hour);
    myFormData.append("start_min", otherInfo.start_min);
    myFormData.append("finish_hour", otherInfo.finish_hour);
    myFormData.append("min_order_amount", otherInfo.min_order_amount);
    myFormData.append("finish_min", otherInfo.finish_min);
    myFormData.append("title", otherInfo.title);
    myFormData.append("line_ids", line_idsj);
    myFormData.append("address", otherInfo.address);
    myFormData.append("site", otherInfo.site);
    myFormData.append("instagram", otherInfo.instagram);
    myFormData.append("bank_info", JSON.stringify(listInfoBank));

    axios
      .post("http://old-sabadib.tatdemo.ir/superadminapi/edit_supplier", myFormData)
      .then(res => {
        if (res.data.status === 1) {
          setDisabledBtn(false);
          toast.success("اطلاعات با موفقیت ویرایش شد!");
          setIsLoading(false);
          setUpdater(!updater);
          inputElement.current.click();
          setDisplayStatusUser("d-none");
          if (otherInfo.fullname != "") {
            setOtherInfo({
              ...otherInfo,
              fullname: "",
              user_mobile: ""
            });
          }
        } else {
          toast.error("خطا در ویرایش اطلاعات!");

          setIsLoading(false);
          setDisabledBtn(false);
        }
      });
  }

  function inputChangeHandler(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }
  const changeHandlerImg = e => {
    setOtherInfo({ ...otherInfo, [e.target.name]: e.target.files[0] });
  };
  function handleChange(event) {
    setOtherInfo({
      ...otherInfo,
      [event.target.name]: removeCommas(event.target.value)
    });
  }

  const changeHandler = (names, value) => {
    if (names == "start") {
      setOtherInfo(prev => {
        return {
          ...prev,
          start_hour: value.split(":")[0],
          start_min: value.split(":")[1]
        };
      });
    } else if (names == "finish") {
      setOtherInfo(prev => {
        return {
          ...prev,
          finish_hour: value.split(":")[0],
          finish_min: value.split(":")[1]
        };
      });
    }
  };
  const inputRef = useRef();

  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.fullname = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].fullname;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  const translateLinesToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.title = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };

  const [user, setuser] = useState([]);
  useEffect(() => {
    connection("superadminapi/get_add_suppliers_data").then(data => {
      setuser(prev => {
        return [
          { fullname: "ثبت کاربر جدید", id: "-1" },
          ...data.user_for_admin
        ];
      });
    });
  }, [updater]);
  const userOptions = translateUserToReactSelect(user, false);
  const [displayStatusUser, setDisplayStatusUser] = useState("d-none");
  const changeHandleraTags = option => {
    setOtherInfo(prev => {
      let temp = { ...prev };
      temp.line_ids = option;
      return { ...temp };
    });
  };
  function inputChangeHandlerDaste(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
    setFilterCat(event.target.value);
  }
  const test = allProductTags.filter(
    item => item.parent_line_id == 0
    // {
    //   if (item.main_cat == otherInfo.main_cat && item.parent_line_id == 0) {
    //     return item;
    //   }
    // }
  );

  useEffect(() => {
    otherInfo.bank_info != "" &&
      setListInfoBank(JSON.parse(otherInfo.bank_info));
  }, [otherInfo]);

  const [valid, setValid] = useState({
    title: true,
    tell1: true,
    tell2: true,
    mobile: true,
    user_mobile: true
  });
  const validate = () => {
    let isValide = true;
    if (otherInfo.title == "") {
      setValid(prev => {
        return { ...prev, title: false };
      });
      isValide = false;
    } else {
      setValid(prev => {
        return { ...prev, title: true };
      });
      isValide = true;
    }
    if (pattern.test(otherInfo.mobile) || otherInfo.mobile == "") {
      setValid(prev => {
        return { ...prev, mobile: true };
      });
    } else if (!pattern.test(otherInfo.mobile)) {
      setValid(prev => {
        return { ...prev, mobile: false };
      });
      isValide = false;
    }
    if (tellPattern.test(otherInfo.tell1) || otherInfo.tell1 == "") {
      setValid(prev => {
        return { ...prev, tell1: true };
      });
    } else if (!tellPattern.test(otherInfo.tell1)) {
      setValid(prev => {
        return { ...prev, tell1: false };
      });
      isValide = false;
    }
    if (tellPattern.test(otherInfo.tell2) || otherInfo.tell2 == "") {
      setValid(prev => {
        return { ...prev, tell2: true };
      });
    } else if (!tellPattern.test(otherInfo.tell2)) {
      setValid(prev => {
        return { ...prev, tell2: false };
      });
      isValide = false;
    }

    // if (pattern.test(otherInfo.user_mobile) || otherInfo.user_mobile == "") {
    //   setValid(prev => {
    //     return { ...prev, user_mobile: true };
    //   });
    // } else if (!pattern.test(otherInfo.user_mobile)) {
    //   setValid(prev => {
    //     return { ...prev, user_mobile: false };
    //   });
    //   isValide = false;
    // }

    return isValide;
  };
  const showUser = () => {
    let x = [];
    x = userOptions.filter(v => v.value == otherInfo.main_admin_uid);
    return x;
  };
  return (
    <>
      <div
        class="modal fade add-campain"
        id={`exampleModalE`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کسب و کار
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="shop-setting d-flex justify-content-center">
                <form className="w-100 d-flex flex-column align-items-center">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-title"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        نام فروشگاه
                      </label>
                      <div className="col-12 col-sm-9">
                        {/* <input
                type="text"
                id="shop-title"
                style={{background:"#ddd"}}
                className={`form-control gray-input ${title.hasError ? " invalid" : ""}`}
                value={title.value}
                onChange={title.changeHandler}
                onBlur={title.blurHandler}
              /> */}
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-title"
                          name="title"
                          className="form-control"
                          value={otherInfo.title}
                          onChange={inputChangeHandler}
                        />
                        <p
                          className="validate-text"
                          style={{
                            display: !valid.title ? "block" : "none"
                          }}
                        >
                          نام فروشگاه نمی تواند خالی باشد
                        </p>
                      </div>
                      {/* {title.hasError && (
                      <div className="text-danger">
                        نام فروشگاه نمیتواند خالی باشد.
                      </div>
                      )} */}
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        دسته بندی
                      </label>
                      <div className="col-12 col-sm-9">
                        <select
                          name="main_cat"
                          class="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          style={{
                            background: "#ddd",
                            direction: "rtl",
                            padding: "9px"
                          }}
                          value={otherInfo.main_cat}
                          onChange={inputChangeHandlerDaste}
                        >
                          {allLeader?.map((value, index) => (
                            <option key={index} value={index}>
                              {value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-2">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-leastOrders"
                        className="form-label col-12 col-sm-3"
                      >
                        حداقل سفارش
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-leastOrders"
                          name="min_order_amount"
                          className="form-control"
                          value={addCommas(otherInfo.min_order_amount)}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* کاربر */}
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="user"
                        className="form-label col-12 col-sm-3"
                      >
                        کاربر
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          className=" filterSelect "
                          id="user"
                          options={userOptions}
                          value={showUser()}
                          onChange={e => {
                            setOtherInfo(prev => {
                              return { ...prev, main_admin_uid: e.value };
                            });

                            if (e.value == "-1") {
                              setDisplayStatusUser("d-block");
                            } else {
                              setDisplayStatusUser("d-none");
                            }
                          }}
                        />
                      </div>
                    </div>
                    {/* ایجاد کاربر جدید */}
                    <div
                      className={`d-flex ${displayStatusUser} rounded`}
                      style={{ border: "1px dashed lightgray" }}
                    >
                      <div className="w-50 p-1">
                        <label>نام کاربر</label>
                        <input
                          className="form-control"
                          type="text"
                          name="fullname"
                          value={otherInfo.fullname}
                          onChange={inputChangeHandler}
                        ></input>
                      </div>
                      <div className="w-50 p-1">
                        <label>موبایل کاربر</label>
                        <input
                          className="form-control"
                          type="number"
                          name="user_mobile"
                          value={otherInfo.user_mobile}
                          onChange={inputChangeHandler}
                        ></input>
                        <p
                          className="validate-text"
                          style={{
                            display: !valid.user_mobile ? "block" : "none"
                          }}
                        >
                          شماره وارد شده صحیح نیست.
                        </p>
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-main_admin_uid"
                        className="form-label col-12 col-sm-3"
                      >
                        لاین
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          id="tags"
                          className=" filterSelect "
                          options={test}
                          placeholder="لطفا لاین را انتخاب کنید"
                          // {
                          //   test.length > 0 ? (
                          //     <div> لطفا لاین را انتخاب کنید</div>
                          //   ) : (
                          //     <div> دسته بندی را انتخاب کنید</div>
                          //   )
                          // }
                          value={otherInfo.line_ids}
                          onChange={changeHandleraTags}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        ساعت کار فروشگاه
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-startTime"
                            name="startTime"
                            className="form-control"
                            value={`${otherInfo.start_hour}:${otherInfo.start_min}`}
                            onChange={e => {
                              changeHandler("start", e.target.value);
                            }}
                            // value={otherInfo.startTime}
                            // onChange={inputChangeHandler}
                          />
                        </div>
                        <label
                          className="form-label  text-center"
                          style={{ margin: "auto" }}
                        >
                          الی
                        </label>
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-endTime"
                            name="endTime"
                            className="form-control"
                            value={`${otherInfo.finish_hour}:${otherInfo.finish_min}`}
                            onChange={e => {
                              changeHandler("finish", e.target.value);
                            }}
                            //   value={otherInfo.endTime}
                            //   onChange={inputChangeHandler}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <form className="w-100 d-flex flex-column align-items-center form2">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-address"
                        className="form-label col-12 col-sm-3"
                      >
                        آدرس
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-address"
                          name="address"
                          className="form-control"
                          value={otherInfo.address}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-description"
                        className="form-label col-12 col-sm-3"
                      >
                        توضیحات
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-description"
                          name="description"
                          className="form-control"
                          value={otherInfo.description}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-logo_file_id"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        لوگو
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="logo_file_id"
                          className="form-control"
                          type="file"
                          id="shop-logo_file_id"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-cover_file_id"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        کاور
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="cover_file_id"
                          className="form-control"
                          type="file"
                          id="shop-cover_file_id"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell1"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-tell1"
                          name="tell1"
                          className="form-control"
                          value={otherInfo.tell1}
                          onChange={inputChangeHandler}
                        />
                        <p
                          className="validate-text"
                          style={{ display: !valid.tell1 ? "block" : "none" }}
                        >
                          شماره وارد شده صحیح نیست.
                        </p>
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell2"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن 2
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-tell2"
                          name="tell2"
                          className="form-control"
                          value={otherInfo.tell2}
                          onChange={inputChangeHandler}
                        />
                        <p
                          className="validate-text"
                          style={{ display: !valid.tell2 ? "block" : "none" }}
                        >
                          شماره وارد شده صحیح نیست.
                        </p>
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        موبایل
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-mobile"
                          name="mobile"
                          className="form-control"
                          value={otherInfo.mobile}
                          onChange={inputChangeHandler}
                        />
                        <p
                          className="validate-text"
                          style={{
                            display: !valid.mobile ? "block" : "none"
                          }}
                        >
                          شماره وارد شده صحیح نیست.
                        </p>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-email"
                        className="form-label col-12 col-sm-3"
                      >
                        ایمیل
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-email"
                          name="email"
                          className="form-control"
                          value={otherInfo.email}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-site"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        وبسایت
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-site"
                          name="site"
                          className="form-control"
                          value={otherInfo.site}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-instagram"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        اینستاگرام
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-instagram"
                          name="instagram"
                          className="form-control"
                          value={otherInfo.instagram}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                style={{
                  background: "#668cd9",
                  width: "200px",
                  height: "50px",
                  color: "white",
                  padding: "7px",
                  textAlign: "center",
                  borderRadius: "7px 7px 0px 0px",
                  fontSize: "18px",
                  fontWeight: "bold"
                }}
              >
                اطلاعات بانکی
              </div>
              <div
                style={{
                  backgroundColor: "#668cd9",
                  width: "100%",
                  height: "100%",
                  color: "white",
                  borderRadius: "7px 0px 7px 7px",
                  position: "relative"
                }}
              >
                <div className="row p-3">
                  <div className="col-12 col-lg-6 mt-4">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="numberCart "
                        className=" col-12 col-sm-3"
                        style={{
                          // margin: "auto",
                          whiteSpace: "nowrap"
                        }}
                      >
                        شماره کارت{" "}
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="number"
                          id="numberCart"
                          name="numberCart"
                          className="form-control"
                          value={infoBank.numberCart}
                          onChange={e => {
                            setInfoBank({
                              ...infoBank,
                              numberCart: e.target.value
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              infoBankValid.numberCart == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا شماره کارت را به درستی وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mt-4">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="nameBank"
                        className=" col-12 col-sm-3"
                        style={{
                          // margin: "auto",
                          whiteSpace: "nowrap"
                        }}
                      >
                        نام بانک{" "}
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="nameBank"
                          name="nameBank"
                          className="form-control"
                          value={infoBank.nameBank}
                          onChange={e => {
                            setInfoBank({
                              ...infoBank,
                              nameBank: e.target.value
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              infoBankValid.nameBank == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا نام بانک را وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mt-4">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="cartType"
                        className=" col-12 col-sm-3"
                        style={{
                          //  margin: "auto",
                          whiteSpace: "nowrap"
                        }}
                      >
                        نوع کارت{" "}
                      </label>
                      <div className="col-12 col-sm-9">
                        <div className="w-100">
                          <Select
                            placeholder="انتخاب کنید.."
                            style={{
                              background: "#ddd",
                              width: "100%",
                              color: "black"
                            }}
                            id="cartType"
                            options={cartType}
                            name="cartType"
                            value={infoBank.cartType}
                            onChange={e => {
                              setInfoBank(prev => {
                                return { ...prev, cartType: e };
                              });
                            }}
                          />
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              visibility:
                                infoBankValid.cartType == ""
                                  ? "visible"
                                  : "hidden"
                            }}
                          >
                            لطفا نوع کارت را مشخص کنید.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mt-4">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="accountNumber"
                        className=" col-12 col-sm-3"
                        style={{
                          //  margin: "auto",
                          whiteSpace: "nowrap"
                        }}
                      >
                        شماره حساب{" "}
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="number"
                          id="accountNumber"
                          name="accountNumber"
                          className="form-control"
                          value={infoBank.accountNumber}
                          onChange={e => {
                            setInfoBank({
                              ...infoBank,
                              accountNumber: e.target.value
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              infoBankValid.accountNumber == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          لطفا شماره حساب را به درستی وارد کنید.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap mt-4 mb-3">
                    <label
                      htmlFor="Shebanumber"
                      className="col-12 "
                      style={{
                        // margin: "auto",
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره شبا{" "}
                    </label>

                    <div className=" col-12">
                      <input
                        style={{ background: "#ddd" }}
                        type="number"
                        id="Shebanumber"
                        name="Shebanumber"
                        className="form-control"
                        value={infoBank.Shebanumber}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            Shebanumber: e.target.value
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            infoBankValid.Shebanumber == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا شماره شبا را به درستی وارد کنید.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#eb4b97",
                  width: "30px",
                  position: "absolute",
                  marginRight: "45%",
                  marginTop: "-18px",
                  borderRadius: "100%",
                  paddingRight: "9px",
                  paddingTop: "0px",
                  cursor: "pointer",
                  color: "white",
                  fontSize: "20px"
                }}
                onClick={() => {
                  if (InfoBankValidation()) {
                    setInfoBank({
                      numberCart: "",
                      nameBank: "",
                      cartType: "",
                      Shebanumber: "",
                      accountNumber: ""
                    });
                    setListInfoBank(prev => {
                      let temp = [...prev];
                      //temp.push(infoBank);
                      return [...temp, { ...infoBank, checked: true }];
                    });
                  }
                }}
              >
                +{" "}
              </div>
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
                style={{ margin: "12px" }}
              >
                {listInfoBank.length > 0 ? (
                  <>
                    {listInfoBank?.map((value, index) => {
                      return (
                        <div
                          key={index}
                          className="d-flex flex-row px-3 my-3 mx-12 text-center text-md-start"
                          style={{
                            border: "2px solid #A7A9D6",
                            borderRadius: "10px"
                            // width: "48%",
                          }}
                        >
                          <div
                            className="form-check form-switch"
                            style={{ paddingTop: "13px" }}
                          >
                            <input
                              className="form-check-input"
                              name="checked"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              onChange={event => {
                                event.persist();
                                setListInfoBank(prev => {
                                  let temp = [...prev];
                                  temp[index].checked = event.target.checked;

                                  return temp;
                                });
                              }}
                              checked={listInfoBank[index].checked}
                            />
                          </div>

                          <div className="d-flex flex-column justify-content-around w-100">
                            <div className="d-flex flex-column justify-content-between flex-wrap ">
                              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                                <div>
                                  <div className="d-xl-flex-row justify-content-between">
                                    <div>شماره کارت : {value.numberCart}</div>
                                    <div>نام بانک : {value.nameBank}</div>
                                  </div>
                                  <div>نوع کارت : {value.cartType.label}</div>
                                  <div>شماره حساب: {value.accountNumber}</div>
                                  <div>شماره شبا: {value.Shebanumber}</div>
                                </div>
                                <div className="d-flex ">
                                  <div>
                                    <h4 data-tip="حذف ">
                                      <RiDeleteBin5Line
                                        className="tlg1"
                                        onClick={() => RemoveInfoBank(index)}
                                      />
                                    </h4>
                                    <ReactTooltip />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={inputElement}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  console.log("balidate", validate());
                  if (validate()) {
                    postHandler(otherInfo);
                  }
                }}
                disabled={disabledBtn}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;
{
  /* <input
type="text"
className="form-control"
value={customers[index].status}
onChange={(e) =>
  EditUser((prev) => {
    let temp = [...prev];
    temp[index][e.target.name] = e.target.value;
    return [...temp];
  })
}
name="status"
id="address-edit-user"
/>
</div> */
}
